<template>
  <div v-if="data.length" class="resource">
    <div v-for="(item,index) in data" :key="index"
         class="resource-content"
    >
      <div class="text">
        <h2>{{ getContent(item).title }}</h2>
        <p>{{ getContent(item).description }} </p>
      </div>
      <div class="list-wrap">
        <div v-if="getContent(item).showAll&&getContent(item).resourceList.length>6" class="more-btn" @click="viewAll(item)">
          Learn more
          <div class="right-icon">
            <i class="iconfont icon-more-slim" />
          </div>
        </div>
        <div v-if="getContent(item)&&getContent(item).resourceList&&getContent(item).resourceList.length" class="resources-list">
          <ResourceItem v-for="(resourceItem,resourceIndex) in (getContent(item).showAll? getContent(item).resourceList.slice(0,6):getContent(item).resourceList)" :key="`resource-${resourceIndex}`"
                        v-sa-track="[{type: 'visually', event: 'resources_card_show', data: getTrackData( resourceItem,item)}]" :sa-data="getTrackData( resourceItem,item)" :data="resourceItem" :type="item.type"
          />
        </div>
      </div>
    </div>
  </div>
  <div v-else class="exception-wrap">
    <Exception placeholder-class-name="no-avalible-data-img" tip-text="There are no resources under this category" />
  </div>
</template>
<script>

import ResourceItem from 'components/resources/ResourceItem'
import Exception from 'components/common/Exception/index.vue';

export default {
  components: { ResourceItem, Exception },
  props: {
    data: {
      default: () => [],
      type: Array,
    },
  },
  data() {
    return {

    }
  },
  computed: {
    selectedResourcesChannelId() {
      return this.$store.state.channel.selectedResourcesChannelId
    },
  },
  mounted() {
  },
  methods: {
    getTrackData(resourceItem, item) {
      const data = {
        belong_column: this.getContent(item).title,
        resources_id: item.id,
        resources_title: resourceItem.title,
        card_type: item.type === 13 ? 2 : 1,
        previous_source: this.$route.name === 'resources-list-moduleId' ? 'resources list' : 'free resources',
      }
      return data
    },
    viewAll(item) {
      const { id } = item
      this.$router.push(`/resources/list/${id}?channel=${this.selectedResourcesChannelId}`)
    },

    getContent(val) {
      return JSON.parse(val.content)
    },
  },
}
</script>
<style lang="scss" scoped>

  .exception-wrap {
    width: 780px;
  }

  .resource-content {
    padding: 5px;
    width: 780px;
    background-image: url("~assets/images/resources/group_bg.png") var(--txt-color-link);
    background-repeat: no-repeat;
    background-position: right 0, 0 0;
    background-size: 162px 206px, 100%;
    border-radius: 16px;
    margin-top: 40px;

    .text {
      padding: 25px;

      h2 {
        font-size: 32px;
        font-weight: 600;
        color: var(--txt-color-lv1);
        line-height: 38px;
      }

      p {
        margin-top: 12px;
        font-size: 16px;
        font-weight: 500;
        color: var(--txt-color-lv1);
        line-height: 19px;
      }
    }

    .list-wrap {
      position: relative;

      .more-btn {
        display: flex;
        justify-content: space-around;
        align-items: center;
        width: fit-content;
        padding: 6px 28px;
        position: absolute;
        top: -28px;
        right: 14px;
        background: url("~assets/images/resources/more_bg.png") no-repeat;
        background-size: contain;
        font-size: 14px;
        font-weight: 600;
        color: var(--txt-color-link3);
        line-height: 16px;
        cursor: pointer;

        .right-icon {
          width: 14px;
          height: 14px;
          display: flex;
          justify-content: space-around;
          align-items: center;
          background: var(--txt-color-link3);
          border-radius: 50%;
          margin-left: 5px;
          color: var(--txt-color-link);

          i {
            font-size: 14px;
          }
        }
      }

      .resources-list {
        margin-top: 5px;
        background: var(--txt-color-link3);
        border-radius: 12px;
        padding: 5px;
      }
    }
  }

</style>
